import api from './client'

export interface LoginCredentials {
  email: string
  password: string
}

export interface TokenResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  // docs/plan-license-expiry-read-only.md — on login, refresh and activate,
  // so the client can show the expiry banner without guessing from a 423.
  license_active: boolean
  license_expires_at: string | null
}

export interface DeviceRegisterRequest {
  device_id: string
  platform: string
  app_version?: string
}

export const authApi = {
  login: (credentials: LoginCredentials) =>
    api.post<TokenResponse>('/auth/login', credentials),

  // Revokes the session backing this refresh token (docs/plan-security-
  // hardening-1.md §2). The one actual refresh call (used by client.ts's
  // 401 interceptor, with its own race-dedup) stays there, not here.
  logout: (refreshToken: string) =>
    api.post('/auth/logout', { refresh_token: refreshToken }),

  registerDevice: (request: DeviceRegisterRequest) =>
    api.post('/auth/device-register', request),
}
